import React from "react";

function Steps({ img, title, desc }) {
  return (
    <>
      <div className="d-flex align-items-center gap-2 pb-5">
        <img src={img} alt="" />
        <div>
          <h5>
            <b>{title}</b>
          </h5>
          <p className="m-0">{desc}</p>
        </div>
      </div>
    </>
  );
}

export default Steps;
